import { render, staticRenderFns } from "./Philoshophy.vue?vue&type=template&id=6098ed05&"
import script from "./Philoshophy.vue?vue&type=script&lang=js&"
export * from "./Philoshophy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports